import { render } from "./Have30YearsPage.vue?vue&type=template&id=887e6438"
import script from "./Have30YearsPage.vue?vue&type=script&lang=js"
export * from "./Have30YearsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__